import styled from 'styled-components';
import { IoClose } from 'react-icons/io5';
import { FiPlus } from 'react-icons/fi';
import { subMenuDropdownBackground } from '../../config/colors';
import common from '../../styles/common';
import Button from '../Button';

export const Wrapper = styled.div`
  min-width: 70rem;
  min-height: 25rem;
  position: relative;
  padding: 1.5rem;
  background-color: ${subMenuDropdownBackground};
`;

export const ModalTitle = styled.p`
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 2rem;
`;

export const CloseButton = styled(Button).attrs({
  wrapperStyle: {
    position: 'absolute',
    top: 10,
    right: 10,
    width: '1.75rem',
    height: '1.75rem',
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  type: 'rounded',
  icon: IoClose,
  iconProps: {
    color: 'rgba(0,0,0,0.7)',
    size: '1.75rem',
  },
})``;

export const ContentWrapper = styled.div`
  display: flex;
`;
